import React from "react";
import styles from "./contactus.module.scss";
import { Heading, Link, Text } from "@radix-ui/themes";

const ContactUs: React.FC = () => {
  return (
    <div className={`container ${styles.contactusContainer}`}>
      <Heading as="h1" color="blue">
        Contact Us
      </Heading>
      <Text>
        User can contact to our email id{" "}
        <Link href="mailto:admin@quickbusride.com">admin@quickbusride.com</Link>{" "}
        in case of any information required.
      </Text>
      {/* <p>If you have any questions, feedback, or need support, please reach out to us using the form below or via email.</p>
      <form className={styles.contactForm}>
        <div>
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div>
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div>
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows={5} required></textarea>
        </div>
        <button type="submit">Send Message</button>
      </form> */}
    </div>
  );
};

export default ContactUs;
